<div class="modal-header">
  <h4 class="modal-title uppercase">{{ learnGroup.id ? "Edit" : "Add" }} {{ learnGroup.type }}</h4>

  <span type="mode" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </span>
</div>
<div class="modal-body add-edit-learn-group" ngbAutofocus>
  @if (learnGroup.type != "folder") {
    <div class="form-group">
      <small class="text-muted">Status</small>
      <select class="form-control" [(ngModel)]="learnGroup.status">
        <option value="pending">Pending</option>
        <option value="approved">Approved</option>
      </select>
      <small class="text-muted">This will not display at all for customers unless it is Approved.</small>
    </div>
  }
  <div class="form-group">
    <small class="text-muted">Title*</small>
    <input class="form-control" [(ngModel)]="learnGroup.title" />
  </div>
  <div class="form-group">
    <small class="text-muted">Image</small>
    @if (learnGroup.image) {
      <img class="w-full image-border" [src]="learnGroup.image" />
    }
    <span class="small-btn" (click)="addImage()">{{ learnGroup.image ? "Change" : "Add" }} Image</span>
  </div>
  <div class="form-group">
    <small class="text-muted">Description{{ learnGroup.type != "folder" ? "*" : "" }}</small>
    <textarea type="text" name="description" style="height: 120px" id="description" [(ngModel)]="learnGroup.description" class="form-control"></textarea>
  </div>
  <div class="form-group">
    <small class="text-muted">Snippet{{ learnGroup.type != "folder" ? "*" : "" }}</small>
    <textarea type="text" name="snippet" style="height: 60px" id="snippet" [(ngModel)]="learnGroup.snippet" class="form-control"></textarea>
  </div>
  <div class="form-group">
    <small class="text-muted">Materials</small>
    <!-- <img class="w-full image-border" [src]="learnGroup.image" *ngIf="learnGroup.resources_link" /> -->
    @if (learnGroup.resources_link) {
      <myp-list-item icon="file-archive" [title]="learnGroup.resources_link.split('/')[learnGroup.resources_link.split('/').length - 1]" [includeChevron]="false" [showImage]="false"></myp-list-item>
    }
    <span class="small-btn" (click)="addResources()">{{ learnGroup.resources_link ? "Change" : "Add" }} Materials</span>
    <small class="text-muted">Upload a .zip file that users can download for use with this {{ learnGroup.type }}.</small>
  </div>
  @if (learnGroup.type != "folder") {
    <div class="row">
      <div class="form-group col-md-6">
        <small class="text-muted">Level</small>
        <select class="form-control" [(ngModel)]="learnGroup.level">
          <option value="-1">Not Set</option>
          <option value="0">Easy</option>
          <option value="1">Intermediate</option>
          <option value="2">Difficult</option>
          <option value="3">Expert</option>
        </select>
      </div>
      <div class="form-check text-left col-md-6">
        <small class="d-none d-md-block text-muted">&nbsp;</small>
        <div class="m-t-5">
          <input class="m-r-10" type="checkbox" [(ngModel)]="learnGroup.subscription_only" id="subscription_only" />
          <label class="form-check-label" for="subscription_only">Only allow subscribers to watch.</label>
        </div>
      </div>
    </div>
  }

  <myp-segmented-bar
    [white]="true"
    (selected)="selectedSection = $event.id"
    [options]="[
      {
        name: 'Add ' + (learnGroup.type == 'course' ? 'Lessons' : 'Videos'),
        id: 'associate',
        selected: true,
      },
      {
        name: 'Associated Products',
        id: 'flagship_products',
      },
    ]"
  ></myp-segmented-bar>

  @if (selectedSection == "associate") {
    <div class="m-t-20">
      <myp-learn-content-picker [type]="pickerType" [excludeIds]="pickerExcludeIds" [hint]="pickerHint" [placeholder]="pickerPlaceholder" (added)="onPickerAdded($event)"></myp-learn-content-picker>
      @if (learnGroup.type == "course" && learnGroup.lessons && learnGroup.lessons?.length) {
        <div class="d-flex justify-content-between">
          <span class="t-14 gothic">Lessons In This Course</span>
          @if (learnGroup.lessons.length > 1) {
            <span class="t-12 text-muted">Drag and Drop to Reorder.</span>
          }
        </div>
        <div dragula="LESSONS" [(dragulaModel)]="learnGroup.lessons">
          @for (lesson of learnGroup.lessons; track lesson) {
            <myp-learn-list-item [large]="false" (removed)="removeLesson(lesson)" [showRemove]="true" [item]="lesson"></myp-learn-list-item>
          }
        </div>
      }
      @if ((learnGroup.type == "lesson" || learnGroup.type == "folder") && learnGroup.videos && learnGroup.videos?.length) {
        <div class="d-flex justify-content-between">
          <span class="t-14 gothic">Videos In This {{ learnGroup.type == "lesson" ? "Lesson" : "Folder" }}</span>
          @if (learnGroup.videos.length > 1) {
            <span class="t-12 text-muted">
              Drag and Drop to Reorder.
              <span class="link" (click)="sortVideos()">Sort By Date</span>
            </span>
          }
        </div>
        <div dragula="VIDEOS" [(dragulaModel)]="learnGroup.videos">
          @for (video of learnGroup.videos; track video) {
            <myp-video-list-item (removed)="removeVideo(video)" [showRemove]="true" [video]="video"></myp-video-list-item>
          }
        </div>
      }
    </div>
  }

  @if (selectedSection == "flagship_products") {
    <div class="m-t-20">
      <h4 class="section-header m-b-20 m-t-50">Set as Flagship {{ learnGroup.type == "course" ? "Course" : "Lesson" }}</h4>
      <small>
        Find a product below to set this {{ learnGroup.type }} as that product's Flagship {{ learnGroup.type }}. This {{ learnGroup.type }} will be displayed prominently in the product detail page.
      </small>
      <div class="form-group">
        <small class="text-muted">
          Start typing to search products or enter a Fender product SKU...
          @if (searchingFlagshipProducts) {
            <fa-icon icon="spinner" animation="spin" class="m-r-10"></fa-icon>
          }
        </small>
        <input class="form-control" [(ngModel)]="flagshipProductQuery" />
      </div>
      @if (flagshipProductQuery && flagshipProductResults && flagshipProductResults.length) {
        <div class="product-results m-b-30 trans-bg border-radius10 p-10">
          <ng-container>
            @for (product of flagshipProductResults; track product) {
              <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                <div class="button-content">
                  <fa-icon
                    [icon]="updatingFlagshipMap[product.id] ? 'spinner' : 'plus'"
                    [animation]="updatingFlagshipMap[product.id] ? spinAnimation : undefined"
                    placement="left"
                    [ngbTooltip]="'Set This Video as the Flagship Video For This Product'"
                    (click)="setAsFlagship(product)"
                    class="action green circle-icon-btn m-r-10"
                  ></fa-icon>
                </div>
              </myp-list-item>
            }
          </ng-container>
        </div>
      }
      @if (learnGroup.flagship_products && learnGroup.flagship_products.length) {
        <div class="product-results">
          <span class="t-14 gothic">This video is the Flagship Video for the following products</span>
          <ng-container>
            @for (product of learnGroup.flagship_products; track product) {
              <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                <div class="button-content">
                  <fa-icon
                    [icon]="updatingFlagshipMap[product.id] ? 'spinner' : 'minus'"
                    [animation]="updatingFlagshipMap[product.id] ? spinAnimation : undefined"
                    placement="left"
                    [ngbTooltip]="'Remove This Product'"
                    (click)="unsetAsFlagship(product)"
                    class="action red circle-icon-btn m-r-10"
                  ></fa-icon>
                </div>
              </myp-list-item>
            }
          </ng-container>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer d-flex justify-content-between">
  <div>
    @if (learnGroup.id) {
      <button type="button" class="btn btn-danger" (click)="delete()">{{ "general.delete" | translate }}</button>
    }
  </div>
  <div>
    <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    <button type="button" class="btn btn-blank m-r-5" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
</div>
